import * as React from 'react';
import { CustomSubmitButton, CustomSubmitButtonType } from "soprasteria-ui-library";
import { faSave } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../../../../App';
import { ReferralResponseApi } from "../../../../api/ReferralResponseApi";
import { IReferralResponseModel, ISaveReferral } from '../../../../models/IReferral';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useHistory } from 'react-router-dom';
import { REFERRAL } from '../../../../utils/RouteConstants';
import { ManageReferralApi } from '../../../../api/ManageReferralApi';
import { isInRole, UserContext } from '../../../../contexts/UserContext';
import { LIBRETTOADMIN } from '../../../../utils/RoleConstants';
import { AutoSave } from '../../../AutoSave/AutoSave';

interface IReferralSaveButton {
    referralId?: number;
    changeSuccessMessage: (message: string) => void;
    changeErrorMessage: (message: string) => void;
    getReferral: (id: number) => void;
    canWriteAnswer: boolean;
    isEditable: boolean;
    referralStatus: string;
}

export const ReferralSaveButton: React.FunctionComponent<IReferralSaveButton> = ({ canWriteAnswer, isEditable, referralId, getReferral, changeErrorMessage, changeSuccessMessage, referralStatus }) => {

    const auth = useAuth();
    const responseApi = new ReferralResponseApi(auth);
    const manageReferralApi = new ManageReferralApi(auth);
    const [isSaving, setIsSaving] = React.useState<boolean>(false);
    const userInfo = React.useContext(UserContext);
    const hasRoleSystemAdmin = isInRole(LIBRETTOADMIN, userInfo.roles);
    const saveButtonId = "save-referral-button";

    const history = useHistory();

    const saveReferral = (data: any) => {

        if (canWriteAnswer) {
            saveReferralAnswer(data);
        }
        if (isEditable) {
            saveReferralForm(data);
        }
    }

    const saveReferralAnswer = (data: IReferralResponseModel) => {
        if (referralId) {
            setIsSaving(true);
            responseApi.saveReferralAnswer(data, () => {
                getReferral(referralId);
                changeSuccessMessage("Specialistremissen har sparats");
            }, (error: string) => {
                changeErrorMessage(error);
            }, () => {
                setIsSaving(false);
            })
        }
    }

    const saveReferralForm = (data: ISaveReferral) => {
        setIsSaving(true);
        manageReferralApi.saveReferral(data, (newReferralId) => {
            if (referralId === undefined || referralId === 0) {
                history.replace(`${REFERRAL}/${newReferralId}`);
            }
            getReferral(newReferralId);
            changeSuccessMessage("Specialistremissen har sparats");
        }, (error) => {
            changeErrorMessage(error);
        }, () => {
            setIsSaving(false);
        })
    }

    return (
        <>
            {
                !hasRoleSystemAdmin && (canWriteAnswer || isEditable) ?
                    <>
                        <AutoSave saveButtonId={saveButtonId} />
                        <CustomSubmitButton isLoading={isSaving} buttonType={CustomSubmitButtonType.alternative} onButtonSubmit={saveReferral} id={saveButtonId}> <FontAwesomeIcon icon={faSave} /> Spara specialistremiss</CustomSubmitButton>
                    </>
                    : null
            }
        </>
    )
}